<template lang="html">
  <div class="maincompiler">
    <iframe
      class="maincompiler--container"
      id="maincompiler-container"
      frameborder="0"
      v-if="isShowIfr"
      :src="compilerUri"
      :key="compilerUri"
      @load="iframeLoad"
    >
    </iframe>
    <paper-question
      v-else-if="!isShowIfr && isPaper"
      :queData="paperQuestionData"
      :ansData="paperAnswerData"
      :bundleExamStatus="currentParams.params.bundleExamStatus"
      :pattern="pattern"
      :solutionError="solutionError"
      @ensure="paperQuestionEnsure"
      @next="paperQuestionNext"
      :isLastQuestion="currentParams.params.isLastQuestion"
      :readonly="!currentParams.params.canSave"
    />
    <choice-question
      v-else
      :bundleExamStatus="currentParams.params.bundleExamStatus"
      :question="question"
      @ensure="choiceEnsure"
      @choiceFinish="choiceFinish"
      :isLastQuestion="currentParams.params.isLastQuestion"
      :readonly="!currentParams.params.canSave"
    />
    <Eyecare v-if="showEyecare" :hidden="isEyecareHidden" :class="eyecareClass"/>
    <SavedTime :time="savedTime" :class="saveClass"/>
  </div>
</template>

<script type="text/babel">

import { Message } from 'element-ui';
// import loading from '@/utils/loading';
import comUrl from '@/utils/uri';
import ChoiceQuestion from '@/components/ChoiceQuestion.vue';
import PaperQuestion from '@/components/PaperQuestion.vue';
import Eyecare from '@/components/Eyecare.vue';
import SavedTime from '@/components/SavedTime.vue';
import { delNull } from '@/utils/delNull';
import { addURLParams } from '@/utils/query-string';
import { getPaperQuestion } from '@/services/compiler';
import {
  getStudentAnswer,
  stdGetPaperAnswer,
} from '@/services/student';
import {
  getQuestion,
  teaGetPaperAnswer,
  getTeacherAnswer
} from '@/services/teacher';
import { debounce } from 'lodash';
import { errorHandler } from '@/utils/errorHandler';
import { setViewBuryingPoint, setClickBuryingPoint } from '@/utils/buryingPoint';
import {mapState} from 'vuex'
import { decode } from 'js-base64';

export default {
  name: 'MainCompiler',

  components: {
    ChoiceQuestion,
    PaperQuestion,
    Eyecare,
    SavedTime,
  },

  props: {
    params: {
      type: Object,
      default: () => {},
    },
    solutionError: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    isCmLast: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isEyecareHidden: true,
      isShowIfr: false,
      compilerUri: '',
      cmProjectId: null,
      question: {
        id: '',
        content: '',
        imageUrl: '',
        optionItems: [],
      },
      pattern: 2,
      isPaper: false,
      paperQuestionData: {},
      paperAnswerData: {},
      savedTime: '', // 保存时间
      showEyecare: false, // 展示护眼模式提示
      buryingPoint: {
        setViewBuryingPoint: (...args) => {
          setViewBuryingPoint(this, ...args);
        },
        setClickBuryingPoint: (...args) => {
          setClickBuryingPoint(this, ...args);
        },
      },
      loadStartTime:null
    };
  },

  computed: {
    ...mapState({
      cp_uid:state => state.user.autoLoginInfo.id,
      cp_id:state => state.router.id,
    }),
    currentParams() {
      return {
        params: this.params,
        index: this.index,
      };
    },
    saveClass() {
      switch (this.params.bundle[this.index].category) {
        case 2:
        case 7:
          return 'save_green';
        default: return '';
      }
    },
    eyecareClass() {
      switch (this.params.bundle[this.index].category) {
        case 2:
        case 7:
          return 'eyes_green';
          // python
        case 5:
        case 6:
          return 'eyes_white';
          // make block
        default: return '';
      }
    },
  },

  watch: {
    currentParams() {
      this.analysisParams();
    },
  },

  methods: {
     XHTOGGLEEYECARE({ payload }) {
      const { hide } = payload || {};
      this.isEyecareHidden = !hide;
    },
    analysisParams() {
      this.loadStartTime = Date.parse(new Date());
      // loading.show();
      this.$vmLoading.show()
      this.savedTime = '';
      switch (this.params.bundle[this.index].category) {
        // codemonkey
        case 1:
          this.JumpCodemonkey();
          break;
        // scratch
        case 2:
          this.JumpScratch();
          break;
        // python
        case 3:
        case 8:
          this.JumpPython();
          break;
        // choice question
        case 5:
          this.showChoice();
          break;
        // cpp
        case 4:
        case 9:
          this.JumpCpp();
          break;
        case 6:
          this.showPaper();
          break;
        default:
      }
    },
    async showPaper() {
      this.isShowIfr = false;
      this.isPaper = true;

      const questionId = this.params.bundle[this.index].projectId;
      this.XHREPORTMONITORTYPE({ payload: 'pv' });

      try {
        this.XHREPORTMONITORTYPE({ payload: 'start' });
        // 获取答案
        let ans = {};
        if (this.params.role === '1') {
          ans = await stdGetPaperAnswer({
            questionId,
            bundleId:this.params.bundleId,
          });
        } else if (this.params.role === '0') {
          ans = await teaGetPaperAnswer({
            questionId,
            classId: this.params.classId,
            lessonId: this.params.lessonId,
            studentId: this.params.studentId,
            bundleId: this.params.bundleId,
          });
          this.pattern = 1;
        }

        // 获取题目
        const que = await getPaperQuestion({ id: questionId, origin: 1 });
        que.data = JSON.parse(decode(que.data));
        this.XHREPORTMONITORTYPE({ payload: 'success' });
        // 题目数据重置
        if (Number(que.data.logicQuesTypeId) === 4) {
          que.data.answerOptionList = null;
        }
        que.data.isDecidable = 1;
        que.data.subjectId = 1;
      
        if (ans.data) {
          this.paperAnswerData = ans.data;
        } else {
          this.paperAnswerData = {};
        }
        this.paperQuestionData = que.data;
        this.handleLoad();
        this.XHLOADED();
        this.XHREPORTMONITORTYPE({ payload: 'project-success' });
      } catch ( { data } ) {
        errorHandler(data)
        // 上报Paper题错误
        this.XHLOADFAILED({ payload: data.message });
      }
    },
    paperQuestionEnsure(obj) {
      this.$emit('paperQuestionEnsure', {
        ...obj,
        classId: this.params.classId,
        lessonId: this.params.lessonId,
        questionId: this.params.bundle[this.index].projectId,
      });
    },
    paperQuestionNext() {
      this.$emit('paperQuestionNext');
    },
    JumpCodemonkey() {
      this.XHREPORTMONITORTYPE({ payload: 'pv' });
      this.isShowIfr = true;
      this.isPaper = false;
      this.XHREPORTMONITORTYPE({ payload: 'start' });
      /* eslint-disable-next-line */
       // 学生查看学生题目 & 教师查看教师题目
        this.cmProjectId = this.params.bundle[this.index].projectId;
        const Id = this.cmProjectId || this.params.bundle[this.index].stuWorkId;
        const cmUri = `${comUrl.cmUrl}${Id || ''}`;

        this.compilerUri = `${addURLParams(cmUri, delNull({
          token: this.params.token,
          canSave: this.params.canSave ? '1' : '0',
          category: this.params.bundle[this.index].category,
        }))}`;
    },
    JumpCpp() {
      this.isShowIfr = true;
      this.isPaper = false;
      this.compilerUri = `${addURLParams(comUrl.cppUrl, delNull({
        // backend's params
        token: this.params.token,
        bundleId: this.params.bundleId,
        projectType: this.params.projectType,
        practiceType: this.params.practiceType,
        practiceId: this.params.bundle[this.index].practiceId,
        category: this.params.bundle[this.index].category,
        studentId: this.params.studentId,
        // frontend's params
        role: this.params.role,
        fr: this.params.fr,
        canSave: this.params.canSave ? '1' : '0',
        canReset: this.params.canSave ? undefined : '0',
        bundleExamStatus:this.params.bundleExamStatus,
        judgeType: this.params.judgeType,
        questionIndex: this.params.questionIndex,
        questionCount: this.params.questionCount,
      }))}#${this.params.bundle[this.index].projectId}`;
      
      // loading.hide();
    },
    JumpScratch() {
      this.isShowIfr = true;
      this.isPaper = false;
      const { stuWorkId, projectId } = this.params.bundle[this.index];
      this.compilerUri = `${addURLParams(comUrl.scratchUrl, delNull({
        // backend's params
        token: this.params.token,
        bundleId: this.params.bundleId,
        studentId: this.params.studentId,
        projectType: this.params.projectType,
        practiceType: this.params.practiceType,
        templateId: projectId,
        category: this.params.bundle[this.index].category,
        // frontend's params
        role: this.params.role,
        fr: this.params.fr,
        canSave: this.params.canSave ? '1' : '0',
        canReset: this.params.canSave ? undefined : '0',
      }))}#${stuWorkId || projectId}`;

    },
    JumpPython() {
      this.isShowIfr = true;
      this.isPaper = false;
      const { pythonType } = this.params.bundle[this.index];
      let pythonUrl = comUrl.pyUrl;
      switch (pythonType) {
        case 11:
          pythonUrl = comUrl.pythonGame;
          break;
        case 12:
          pythonUrl = comUrl.pythonOnline;
          break;
        case 13:
          pythonUrl = comUrl.pyCmUrl;
          break;
        default:
          break;
      }
      this.compilerUri = `${addURLParams(pythonUrl, delNull({
        // backend's params
        token: this.params.token,
        bundleId: this.params.bundleId,
        studentId: this.params.studentId,
        projectType: this.params.projectType,
        projectId: this.params.bundle[this.index].projectId,
        stuWorkId: this.params.bundle[this.index].stuWorkId,
        practiceType: this.params.practiceType,
        category: this.params.bundle[this.index].category,
        // frontend's params
        role: this.params.role,
        fr: this.params.fr,
        canSave: this.params.canSave ? '1' : '0',
        mode: this.params.canSave ? 5 : 6,
        bundleExamStatus: this.params.bundleExamStatus,
        questionIndex: this.params.questionIndex,
        questionCount: this.params.questionCount,
        showHighest: this.params.showHighest,
      }))}#${pythonType === 13 ? '' : this.params.bundle[this.index].projectId}`;

      // loading.hide();
    },
    async showChoice() {
      this.isShowIfr = false;
      this.isPaper = false;
      this.XHREPORTMONITORTYPE({ payload: 'pv' });
      try {
        this.XHREPORTMONITORTYPE({ payload: 'start' });
        const questionId = this.params.bundle[this.index].projectId;
        const { data } = await getQuestion({
          id: questionId,
        });
        // const tmpObj = data;
        const tmpObj = JSON.parse(decode(data));
        tmpObj.questionId = questionId;
        tmpObj.practiceType = Number(this.params.practiceType);
        tmpObj.canSubmit = this.params.canSubmit;
        tmpObj.role = this.params.role;
        this.XHREPORTMONITORTYPE({ payload: 'success' });
        let ansData = {};
        if (this.params.role === '1') {
          ansData = await getStudentAnswer({
            questionId,
            bundleId:this.params.bundleId
          });
        } else if (this.params.role === '0') {
          ansData = await getTeacherAnswer({
            questionId,
            classId: this.params.classId,
            lessonId: this.params.lessonId,
            studentId: this.params.studentId,
            bundleId: this.params.bundleId,
          });
        }
        if (ansData.data) {
          tmpObj.isShowAnswer = true;
          if (ansData.data.result === 1 || ansData.data.result === 3) {
            tmpObj.correct = true;
          } else {
            tmpObj.correct = false;
          }
          tmpObj.optionItems.some((item) => {
            if (item.no === ansData.data.answers) {
              /* eslint-disable-next-line no-param-reassign */
              item.selected = true;
              return true;
            }
            return false;
          });
        } else {
          tmpObj.isShowAnswer = false;
        }
        this.question = tmpObj;
        this.handleLoad();
        this.XHLOADED();
        this.XHREPORTMONITORTYPE({ payload: 'project-success' });
        this.$emit('xhloaded');
      } catch ( { data } ) {
        errorHandler(data)
        Message.error(data.message);
        this.XHLOADFAILED({ payload: data.message });
      }
    },
    iframeLoad() {
      this.handleLoad()
      this.loadEvent()
    },
    handleLoad() {
      const { category } = this.params.bundle[this.index];

      const typeForEventIdMap = {
        1: '156-664', // cm
        2: '156-665', // sc
        3: '156-662', // py
        4: '156-663', // c++
      };
      // scratch, c++, python, cm加载时间埋点(加载时间/s)
      setViewBuryingPoint(this, typeForEventIdMap[category], {}, {
        loaded_time: (Date.parse(new Date()) - this.loadStartTime) / (1000),
      });

      this.$emit('compilerLoaded');
      // loading.hide();

      if (category === 1) {
        this.$emit('xhloaded');
        this.XHLOADED();
      }
      if (this.isCmLast) {
        this.$emit('update:isCmLast', false);
        window.history.back(-1);
      }
    },
    sendMessage(payload) {
      if (window.frames && window.frames.length > 0) {
        const obj = JSON.stringify({
          type: 'XH_SHARE_MENU_STATUS',
          payload,
        });
        Array.from(window.frames).forEach(frame => frame.postMessage(obj, '*'));
      }
    },
    receiveMessage(event) {
      try {
        let { data } = event;
        data = typeof data === 'string' ? JSON.parse(data) : data;
        // console.log(data, 444444)
        const {
          type,
          ...payload
        } = data;

        if (typeof type === 'undefined') return;
        const method = type.replace(/_(\w)/g, (i, s) => s.toUpperCase());
        if (typeof this[method] === 'function') this[method](payload);
      } catch (err) {
        // console.log(err);
      }
    },
    XHCHANGEMENUSTATUS({payload}) {
      if (payload.type === 'loaded') {
        this.sendMessage({ type: 'change', data: {
          current: this.index,
          list: this.params.isLastQuestion ? [0] : [0, 1]
        } });
      }
    },
    XHLOADED() {
      this.closeLoading();
      this.showEyecare = true;
      this.$emit('xhloaded');
    },
    XHREPORTRESULT({ payload }) {
      this.$emit('updateBundle', {
        result: payload.result,
      });
    },
    choiceEnsure(data) {
      this.$emit('choiceEnsure', {
        correct: data.correct,
        chooseAnswer: data.chooseAnswer,
        isCorrect: data.isCorrect,
        answerId: data.answerId,
        questionId: data.questionId,
      });
    },
    choiceFinish() {
      this.$emit('choiceFinish');
    },
    CPPPAGESTATUS({ payload }) {
      this.$emit('cppPageStatus', {
        pageStatus: payload.pageStatus,
      });
    },
    CPPFINISHED() {
      this.$emit('cppFinish');
    },
    XHSAVED() {
      const now = new Date();
      const minute = now.getMinutes();
      const hour = now.getHours();
      this.savedTime = `${hour < 10 ? (`0${hour}`) : hour}:${minute < 10 ? (`0${minute}`) : minute}`;
      this.$emit('saved');
    },
    XHSCRATCHSAVE() {
      const now = new Date();
      const minute = now.getMinutes();
      const hour = now.getHours();
      this.savedTime = `${hour < 10 ? (`0${hour}`) : hour}:${minute < 10 ? (`0${minute}`) : minute}`;
      this.$emit('saved');
    },
     // cm attemp事件
    cmAttempt: debounce(function cmAttempt(data) {
      this.$emit('cmReport', {
        code: data.code,
        stars: 0,
        time: data.time,
        url: data.solutionUrl,
        projectId: this.cmProjectId,
        bundleId:this.params.bundleId,
      });
    }, 1000, { leading: true, trailing: false }),
    // cm庆祝弹窗点完成按钮回调函数
    cmSolutionSaved(data) {
      this.$emit('cmReport', {
        code: data.code,
        stars: data.stars,
        time: data.time,
        url: data.solutionUrl,
        projectId: this.cmProjectId,
        bundleId:this.params.bundleId,
      });
    },
    cmFinish() {
      this.$emit('cmFinish');
    },
    cmReplay() {
      this.$emit('cmRetry');
    },
    cmRetry() {
      this.$emit('cmRetry');
    },
    cmPageLoaded() {
      this.XHREPORTMONITORTYPE({ payload: 'success' });
      this.XHREPORTMONITORTYPE({ payload: 'project-success' });
    },
    closeLoading(){
      this.$vmLoading.hide()
    },
    XHLOADFAILED({ payload }) {
      const param = {
        cp_id:this.cp_id, //小猴竞赛id
        cp_uid:this.cp_uid, //小猴竞赛用户id
        category: (this.params.bundle && this.params.bundle[this.index] && this.params.bundle[this.index].category) || '-', // 类型
        bundle_id: this.params.bundleId, // 题组ID
        question_id: (this.params.bundle && this.params.bundle[this.index] && this.params.bundle[this.index].projectId) || '-', // 题目ID（项目ID）
        index: this.index, // 题号
        error_msg: payload, // 错误信息
      };
      if (!this.isNeedBeListen) return;
      const code = '156-4771';
      setClickBuryingPoint(this, code, {}, param);
    },
    XHREPORTMONITORTYPE({ payload }) {
      const param = {
        cp_id:this.cp_id, //小猴竞赛id
        cp_uid:this.cp_uid, //小猴竞赛用户id
        category: (this.params.bundle && this.params.bundle[this.index] && this.params.bundle[this.index].category) || '-', // 类型
        bundle_id: this.params.bundleId, // 题组ID
        question_id: (this.params.bundle && this.params.bundle[this.index] && this.params.bundle[this.index].projectId) || '-', // 题目ID（项目ID）
        index: this.index, // 题号
        loaded_time: (Date.parse(new Date()) - this.loadStartTime) / 1000,
      };
      Object.keys(param).forEach((key) => {
        if (typeof param[key] === 'undefined') {
          param[key] = '-';
        }
      });
      const actions = new Map([
        ['pv', () => (setClickBuryingPoint(this, '156-4770', {}, param))],
        ['start', () => (setClickBuryingPoint(this, '156-4769', {}, param))],
        ['success', () => (setClickBuryingPoint(this, '156-4768', {}, param))],
        ['project-success', () => (setClickBuryingPoint(this, '156-4767', {}, param))],
      ]);
      try {
        actions.get(payload)();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    XHREPORTFOCUSEVENT() {
      this.$emit('focus')
    },
    XHREPORTBLUREVENT() {
      this.$emit('blur')
    },
    handleCopyEvent(event, type) {
      // let text = ''
      // if (type === 'paste') {
      //   text = event.clipboardData.getData('text');
      // }
      window.parent.postMessage(
        JSON.stringify({
          type
        }),
        '*'
      )
    },
    copyEvent(event) {
      this.handleCopyEvent(event, 'iframe_copy')
    },
    pasteEvent(event) {
      this.handleCopyEvent(event, 'iframe_paste')
    },
    cutEvent(event) {
      this.handleCopyEvent(event, 'iframe_cut')
    },
    keydownEvent(event) {
      // 检查是否按下了Ctrl键或者Command键
      const isCtrl = event.ctrlKey || event.metaKey;
      // 检查按下的是否是'C'键
      if (isCtrl && event.key === 'c') {
        // 假设我们要复制的文本是这个
        this.copyEvent(event);
      }
      if (isCtrl && event.key === 'x') {
        // 假设我们要复制的文本是这个
        this.cutEvent(event);
      }
      // 检查按下的是否是'V'键
      if (isCtrl && event.key === 'v') {
        this.pasteEvent(event);
      }
    },
    loadEvent() {
      try {
        const { startBanCopy } = this.$route.query;
        if (Number(startBanCopy)) {
          var iframe = document.getElementById('maincompiler-container');
          // 获取iframe的contentDocument
          var iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
          // 监听复制事件
          iframeDoc.addEventListener('copy', this.copyEvent);
          // 监听粘贴事件
          iframeDoc.addEventListener('paste', this.pasteEvent);
          // 监听剪切事件
          iframeDoc.addEventListener('cut', this.cutEvent);
          // iframeDoc.addEventListener('keydown', this.keydownEvent);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      
    },
    addCopyListener() {
      const { startBanCopy } = this.$route.query;
      if (Number(startBanCopy)) {
        // 监听粘贴事件
        document.addEventListener('paste', this.pasteEvent);
        // 监听复制事件
        document.addEventListener('copy', this.copyEvent);
        // 监听剪切事件
        document.addEventListener('cut', this.cutEvent);
        // document.addEventListener('keydown', this.keydownEvent);
      }
    },
    removeCopyListener() {
      document.removeEventListener('paste', this.pasteEvent);
      document.removeEventListener('copy', this.copyEvent);
      document.removeEventListener('cut', this.cutEvent);
      // document.removeEventListener('keydown', this.keydownEvent);
    }
  },
  created(){
    window.addEventListener('message', this.receiveMessage, false);
    if (Object.keys(this.params).length > 0) {
      this.analysisParams();
    }
  },

  mounted () {
    this.addCopyListener()
  },

  beforeDestroy() {
    window.removeEventListener('message', this.receiveMessage, false);
    this.removeCopyListener()
  },
};
</script>

<style lang="less" rel="stylesheet/less" scoped>
.maincompiler {
  overflow: hidden;
  &--container {
    width: 100%;
    height: 100%;
  }
}
</style>
